// imports
import { useLocation } from "react-router-dom";
import MuiButton from "../../../components/basicComponent/MuiButton";
import Header from "../../../sharedScreens/Header";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useEffect, useState } from "react";
import { UtilService } from "../../../services/shared/UtilService";
import "./Flightbooking.scss";
import PaymentIcon from "@mui/icons-material/Payment";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import QRCode from "qrcode";
import { replaceEMTwithEWTS } from "../../../constants/helper";
import { useGlobalState } from "../../../services/context/AuthContext";

const FlightBookingHistoryDetail = () => {
  const [qrSrc, setQrSrc] = useState("");

  const param = useLocation();
  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";
  const bookingData = param.state?.data || {};
  useEffect(() => {
    const pdfUrl = bookingData?.pdfPath;

    // ✅ Make sure it's a full URL
    if (pdfUrl && pdfUrl.startsWith("http")) {
      QRCode.toDataURL(pdfUrl)
        .then(setQrSrc)
        .catch((err) => {
          console.error("QR code generation failed:", err);
        });
    }
  }, [bookingData?.pdfPath]);
  const outboundSegments =
    bookingData.passengers?.filter((p: any) => p.tripType === "OutBound") || [];
  const inboundSegments =
    bookingData.passengers?.filter((p: any) => p.tripType === "InBound") || [];

  const downloadTicket = async (id: string) => {
    try {
      const response = (await UtilService.downloadTicket(id)) as any;
      // Create a blob link
      const blob = new Blob([response?.data], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link and simulate click
      const link = document.createElement("a");
      link.href = blobUrl;

      // Optional: Use Content-Disposition or fallback filename
      const contentDisposition = response.headers["content-disposition"];
      const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
      const fileName =
        bookingData?.passengers.length > 0
          ? `${bookingData?.passengers?.[0]?.title} ${bookingData?.passengers?.[0]?.firstName} ${bookingData?.passengers?.[0]?.lastName}.pdf`
          : "ticket.pdf";
      const cleanFileName = fileName.replace(/[^\w.-]/g, " ");
      link.download = cleanFileName;

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.log("error while download ticket", error);
    }
  };

  const renderFlightSegment = (segmentList: any, directionLabel: any) => {
    if (segmentList.length === 0) return null;
    const seg = segmentList[0];
    return (
      <div className="container">
        <div className="row booking-history-main-head">
          <div className="col-md-8">
            <div className="flight-header">
              <h4 className="text-lg font-semibold">{directionLabel}</h4>
              <div className="flight-number">
                <h2>
                  {seg?.airlineName} #{seg.airlineNumber}
                </h2>

                <span className="duration">
                  <AccessTimeOutlinedIcon className="fs-5" />
                  <span className="ps-1">
                    {seg.departureTime} - {seg.arrivalTime}
                  </span>
                </span>
              </div>
              <div className="route">
                <div className="location from">
                  <div className="">
                    <span className="location-city"> {seg.origin}</span>
                    <div className="text-muted">Terminal - {seg.Terminal}</div>
                  </div>
                </div>
                <div className="route-divider">
                  <div className="line">
                    <i className="fa-solid fa-plane history-plan-icons"></i>
                  </div>
                </div>
                <div className="location to">
                  <div className="">
                    <span className="location-city"> {seg.destination}</span>
                    <div className="text-muted">Terminal - {seg.Terminal}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4  d-flex flex-column align-items-center justify-content-center pt-3">
            {/* Dummy QR Code using Bootstrap + Placeholder image */}
            <div className="qr-code">
              {qrSrc && <img src={qrSrc} alt="QR Code" width={150} />}
            </div>
            {qrSrc && <h5 className="fw-semibold mb-2">Scan QR</h5>}
          </div>
        </div>
      </div>
    );
  };

  const summary = {
    ADT: 0,
    CHD: 0,
    INF: 0,
    ADT_Total: 0,
    CHD_Total: 0,
    INF_Total: 0,
    Taxes: 0,
    otherCharges: 0,
  };

  bookingData.passengers?.forEach((p: any) => {
    if (p.passengerType === "ADT") {
      summary.ADT++;
      summary.ADT_Total += parseFloat(p.bookingAmount);
    } else if (p.passengerType === "CHD") {
      summary.CHD++;
      summary.CHD_Total += parseFloat(p.bookingAmount);
    } else if (p.passengerType === "INF") {
      summary.INF++;
      summary.INF_Total += parseFloat(p.bookingAmount);
    }
    summary.Taxes += parseFloat(p.taxAmount || 0);
  });

  summary.otherCharges = parseFloat(
    bookingData?.commission?.commissionAmount || "0"
  );

  const grandTotal =
    summary.ADT_Total +
    summary.CHD_Total +
    summary.INF_Total +
    summary.Taxes +
    summary.otherCharges;

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header flex-wrap">
              <h3 className="card-title">Booking History Detail</h3>
            </div>
            <div className="card flightbooking-card mt-2">
              {/* <div className="status-bar">✓ {bookingData.status}</div> */}
              {renderFlightSegment(outboundSegments, "Outbound Flight")}
              {bookingData.fareType === "RoundTrip" &&
                renderFlightSegment(inboundSegments, "Inbound Flight")}
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2 ">
                      <AccountCircleOutlinedIcon /> Passenger Information
                    </h2>
                    <div className="scrollable-x-auto">
                      <table className="table table-bordered">
                        <thead className="thead-light">
                          <tr>
                            <th>#</th>
                            <th>Full Name</th>
                            <th>Trip</th>
                            {/* <th>Type</th> */}
                            <th>Ticket</th>
                            <th>Seat</th>
                            <th>Meal</th>
                            <th>Baggage</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingData.passengers.map((p: any, i: number) => (
                            <tr key={i}>
                              <td className="text-muted">{i + 1}</td>
                              <td className="text-muted">{`${p.title} ${p.firstName} ${p.lastName}`}</td>
                              <td className="text-muted">{p.tripType}</td>
                              {/* <td className="text-muted">{p.passengerType}</td> */}
                              <td className="text-muted">{p.ticketNumber}</td>
                              <td className="text-muted">
                                {p.seatAmount !== "0.00"
                                  ? `${p.seatAmount} {currency}`
                                  : "Not selected"}
                              </td>
                              <td className="text-muted">
                                {p.mealAmount !== "0.00"
                                  ? `${p.mealAmount} {currency}`
                                  : "Not selected"}
                              </td>
                              <td className="text-muted">
                                {p.baggageAllowance || "Not assigned"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* <div className="mt-4">
                    <h4 className="text-lg font-semibold mb-2">Charges</h4>
                    {bookingData.passengers.map((p: any, idx: number) => (
                      <div key={idx} className="border p-2 rounded mb-2">
                        <strong>
                          {p.title} {p.firstName} {p.lastName}
                        </strong>
                        {p.chargeDetails.map((charge: any, i: number) => (
                          <div
                            key={i}
                            className="d-flex justify-content-between"
                          >
                            <span>
                              {charge.isCancellation
                                ? "Cancellation"
                                : "Date Change"}
                            </span>
                            <span>{charge.charge} {currency}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div> */}
                  </div>

                  {/* <div className="col-md-3">
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">
                      <PaymentIcon /> Payment Summary
                    </h2>
                    <div className="bg-light p-3 rounded ">
                      {summary.ADT > 0 && (
                        <div className="d-flex justify-content-between mb-2">
                          <span>Adult x {summary.ADT}</span>
                          <span>{currency} {summary.ADT_Total.toFixed(2)}</span>
                        </div>
                      )}
                      {summary.CHD > 0 && (
                        <div className="d-flex justify-content-between mb-2">
                          <span>Children x {summary.CHD}</span>
                          <span>{currency} {summary.CHD_Total.toFixed(2)}</span>
                        </div>
                      )}
                      {summary.INF > 0 && (
                        <div className="d-flex justify-content-between mb-2">
                          <span>Infant x {summary.INF}</span>
                          <span>{currency} {summary.INF_Total.toFixed(2)}</span>
                        </div>
                      )}
                      {summary.Taxes > 0 && (
                        <div className="d-flex justify-content-between mb-2">
                          <span>Tax</span>
                          <span>{currency} {summary.Taxes.toFixed(2)}</span>
                        </div>
                      )}
                      {summary.otherCharges > 0 && (
                        <div className="d-flex justify-content-between mb-2">
                          <span>Other Charges</span>
                          <span>{currency} {summary.otherCharges.toFixed(2)}</span>
                        </div>
                      )}
                      <div className="border-top my-2 pt-2 d-flex justify-content-between fw-semibold">
                        <span>Grand Total</span>
                        <span>{currency} {grandTotal.toFixed(2)}</span>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="pb-2 user-button w-full text-end onboard-btn mt-0">
                <MuiButton
                  className="main-clear-btn"
                  label="Download Ticket"
                  type="button"
                  endIcon={<DownloadIcon />}
                  onClick={() => downloadTicket(bookingData.bookingTxnId)}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default FlightBookingHistoryDetail;
